<template>
  <div class="background">
  <div class="chart-container">
    <div @click="printPdf" class="noPrint">{{$t('print')}}</div>
    <div class="Hcp-main-header">
      <div class="main-header-left">
        <img src="../../assets/LOGO.png">
      </div>
      <div class="main-header-right">
        <p>{{$t('Records Report')}}</p>
        <p style="font-size: 9px;"></p>
      </div>
    </div>
    <div class="small-hr"></div>
    <div class="statics">
      <p>{{$t('Profile')}}</p>
      <table class="statics-table">
        <tr>
          <td class="td1">{{$t('uername')}}</td><td class="td1">{{$t('Name')}}</td><td class="td1">{{$t('Age')}}</td><td class="td1">{{$t('height')}}</td>
          <td class="td1">{{$t('weight')}}</td><td class="td1">{{$t('disType')}}</td><td  class="td2">{{$t('Duration')}}</td>
        </tr>
        <tr>
          <td class="td3">{{profile.username}}</td><td class="td3">{{profile.name}}</td><td class="td3">{{profile.birthday}}</td>
          <td class="td3">{{profile.height}}</td><td class="td3">{{profile.weight}}</td><td class="td3">{{profile.diabetes_type}}</td>
          <td>{{profile.diabetes_diagnosis_date}}</td>
        </tr>
      </table>
    </div>
    <div class="statics">
      <p>{{$t('Complications')}}</p>
      <table class="statics-table">
        <tr>
          <td class="td1">{{$t('Concomitant diseases')}}</td><td class="td1">{{$t('disDate')}}</td>
          <td  class="td2">{{$t('Suggestion')}}</td>
        </tr>
        <tr v-for="item in complications">
          <td class="td1">{{item[1]}}</td><td class="td1">{{item[2]}}</td><td  class="td2">{{item[3]}}</td>
        </tr>
        <tr><td class="td3"></td><td class="td3"></td><td></td></tr>
      </table>
    </div>
    <div class="statics">
      <p>{{$t('Prescription')}}</p>
      <table class="statics-table">
        <tr>
          <td class="td1">{{$t('Medicine')}}</td><td class="td1">{{$t('Dose')}}</td><td  class="td2">{{$t('Notes')}}</td>
        </tr>
        <tr v-for="item in prescription">
          <td class="td1">{{item[1]}}</td><td class="td1">{{item[2]}}</td><td  class="td2">{{item[3]}}</td>
        </tr>
        <tr><td class="td3"></td><td class="td3"></td><td></td></tr>
      </table>
    </div>
    <div class="statics">
      <p>{{$t('Other suggestions')}}</p>
      <table class="statics-table">
        <tr>
          <td class="td1" style="width: 6%">{{$t('HCP')}}</td><td class="td1" style="width: 10%">{{$t('date')}}</td><td  class="td2">{{$t('Content')}}</td>
        </tr>
        <tr v-for="item in suggestions">
          <td class="td1">{{item[3]}}</td><td class="td1">{{item[1]}}</td><td  class="td2" style="text-align: left">{{item[2]}}</td>
        </tr>
        <tr><td class="td3"></td><td class="td3"></td><td></td></tr>
      </table>
    </div>
  </div>
  </div>
</template>

<script>
  import * as echarts from 'echarts'
  import auth from '../../auth/auth'
  import B64 from '../../auth/base64'
  export default{
    data() {
      return {
        profile:{},complications:[],prescription:[],suggestions:[],
      }
    },
    methods: {
      printPdf(){
        auth.print_page();
      },
    },
    mounted: function () {
      self.document.title =this.$t('Records Report');
      this.profile = JSON.parse(sessionStorage.getItem('Rpro'));
      this.complications = JSON.parse(sessionStorage.getItem('Rcop'));
      this.prescription = JSON.parse(sessionStorage.getItem('Rpre'));
      this.suggestions = JSON.parse(sessionStorage.getItem('Rsug'));
      setTimeout('window.print()',1500);
    },
  }
</script>

<style scoped>
  @page{
    size:auto;
    margin: 0;
  }
  .background{
    padding-top: 5mm;
    width: 100%;
    min-height: 307mm;
    background: #ccc;
  }
  .background .noPrint{
    float: left;
    border-radius:100px;
    background: #fff;
    border: 1px solid #a3a3a3;
    outline: none;
    margin-top:4px;
    width:90px;
    height:26px;
    line-height: 28px;
    cursor: pointer;
    margin-left:-140px;
    font-size: 13px;
    text-align: center;
  }
  @media print {
    .background .noPrint{
      display: none;
    }
  }
  .chart-container {
    width:210mm;
    min-height:307mm;
    font-family:SFUIText-Regular;
    font-size:12px;
    color:#282828;
    letter-spacing:-0.34px;
    background: #fff;
    margin:0 auto;
    padding-left: 20px;
    padding-right: 20px;
  }
  .Hcp-main-header{
    width:97%;
    height:40px;
    margin:0 auto;
    font-family:SFUIText-Regular;
    font-size:12px;
    color:#282828;
    padding-top: 10px;
  }
  .main-header-left{
    float: left;
  }
  .main-header-left img{
    height:45px;
    width: 100px;
  }
  .main-header-right{
    float: right;
    text-align: right;
    padding-top: 10px;
    margin-right: 15px;
  }
  .main-header-right p{
    font-size:12px;
    margin-bottom: 5px;
    letter-spacing:-0.29px;
    font-family:SFUIText-Regular;
    color:#282828;
  }

  .small-hr{
    width:94%;
    margin:10px auto 16px;
    border-top:1px solid #3b3b3b;
  }

  .statics{
    clear: both;
    margin-top: 10px;
    margin-bottom: 35px;
  }
  .statics p{
    font-family:SFUIText-Regular;
    font-size:14px;
    color:#282828;
    letter-spacing:-0.27px;
    margin-left: 4%;
  }
  .statics-table{
    width: 94%;
    margin:10px auto 0;
    border:1px solid #747474;
    font-family:SFUIText-Regular;
    border-collapse: collapse;
    text-align:center;
    word-wrap: break-word;
    word-break: break-all;
  }
  .statics-table td{
    font-size:8px;
    height:16px;
  }
  .statics-table .td1{
    border-bottom:1px solid rgba(116,116,116,0.34);
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .statics-table .td2{
    border-bottom:1px solid rgba(116,116,116,0.34);
  }
  .statics-table .td3{
    border-right:1px solid rgba(116,116,116,0.34);
  }
</style>



// WEBPACK FOOTER //
// record_print.vue?569f0840